import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface MonitorViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class MonitorViewPage extends Component<MonitorViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.monitor(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}